'use strict';
module.exports = function Rect(params) {
	if (!params ||
		!Number.isFinite(params.top) ||
		!Number.isFinite(params.bottom) ||
		!Number.isFinite(params.left) ||
		!Number.isFinite(params.right) ||
		params.top >= params.bottom ||
		params.left >= params.right
	) {
		throw new Error('invalid-args');
	}
	const self = this,
		{top, left, bottom, right} = params,
		width = right - left,
		height = bottom - top;
	self.translate = (offset) => {
		if (!offset) {
			throw new Error('invalid-args');
		}
		return new Rect({
			left: left + offset.x,
			right: right + offset.x,
			top: top + offset.y,
			bottom: bottom + offset.y
		});
	};
	self.intersection = rect => {
		if (!rect) {
			return false;
		}
		if (rect.left < right && rect.right > left && rect.top < bottom && rect.bottom > top) {
			const minX = Math.max(rect.left, left),
				maxX = Math.min(rect.right, right),
				minY = Math.max(rect.top, top),
				maxY = Math.min(rect.bottom, bottom);
			if (minX < maxX && minY < maxY) {
				return new Rect({left: minX, top: minY, right: maxX, bottom: maxY});
			}
		}

		return false;
	};
	self.wrap = rect => {
		const minX = Math.min(rect.left, left),
			maxX = Math.max(rect.right, right),
			minY = Math.min(rect.top, top),
			maxY = Math.max(rect.bottom, bottom);

		return new Rect({
			top: minY,
			left: minX,
			bottom: maxY,
			right: maxX
		});
	};
	Object.freeze(Object.assign(self, {top, left, bottom, right, width, height}));
};
